// noinspection GraphQLUnresolvedReference

import { gql } from 'graphql-request'

/**
 * Fragmento de tipo articulo
 */
export const tipoArticuloFragment = gql`
  fragment tipoArticuloFragment on TipoArticulo {
    _id
    codigo
    descripcion
    notas
    state
    usucre
    createdAt
    usumod
    updatedAt
  }
`
